<div class="modal-content" *ngIf="params['component'] === 'SrConfiguration'">
    <div class="modal-header">
        <h4 class="modal-title help-btn">
            {{ params['title'] | translate }}
        </h4>
    </div>
    <div class="modal-body">
        <button type="button" class="btn btn-link close" (click)="hide()" aria-label="Close">

        </button>
        <!--action buttons-->
        <div *ngIf="params['action'] === 'read'">
            <ul class="list-inline">
                <li class="list-inline-item">
                    <button class="btn btn-link" (click)="openFormModal.emit();">
                        <i class="fas fa-pencil-alt text-primary" aria-hidden="true"></i>
                        <span>{{ 'Edit' | translate }}</span>
                    </button>
                </li>
                <li class="list-inline-item">
                    <button class="btn btn-link" (click)="delete.emit();">
                        <i class="far fa-trash-alt text-primary" aria-hidden="true"></i>
                        <span>{{ 'Delete' | translate }}</span>
                    </button>
                </li>
            </ul>
            <hr/>
        </div>

        <ng-template [ngIf]="!formLoading">
            <form [formGroup]="form" novalidate class="mat-form" #formDirective="ngForm">
                <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                    <div class="col-sm-10">
                        <div class="alert alert-danger">
                            <div *ngFor="let error of errorMessage">
                                <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="responseMessage" class="row form-group" role="alert">
                    <div class="col-sm-10">
                        <div class="alert-success alert">
                            <i class="fas fa-check" aria-hidden="true"></i> {{ responseMessage | translate }}
                        </div>
                    </div>
                </div>

                <div *ngIf="showWarning" class="row form-group" role="alert">
                    <div class="col-sm-10">
                        <div class="alert-danger alert">
                            <i class="fas fa-exclamation-circle" aria-hidden="true"></i> {{ 'Please save all data first' | translate }}
                        </div>
                    </div>
                </div>

                <div *ngIf="this.authService.isSuperAdmin" class="mt-2 row">
                    <div #domainName class="form-group col-xs-4">
                        <mat-form-field
                                class="ps-content"
                                *ngIf="this.authService.isSuperAdmin">
                            <mat-select (selectionChange)="collectFeelings($event)"
                                        #matDomain
                                        [disabled]="!domains || domains.length < 1"
                                        [placeholder]="'Domains' | translate"
                                        class="matSelect-domains"
                                        [(ngModel)]="domainIds"
                                        [ngModelOptions]="{standalone: true}"
                                        multiple>
                                <ng-container *ngFor="let domain of domains">
                                    <mat-option [class.hidden]="domain['hidden']" [selected]="form.controls['items']?.value?.indexOf(domain['id']) > -1" [value]="domain['id']">
                                        {{ domain['name_' + itemLanguage] | translate }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="table--grid mt-2 sr-layers">
                    <div class="table--grid__header">
                        <i class="far fa-trash-alt delete-tab" *ngIf="totalSteps > 1"
                           attr.name="{{ 'Delete' | translate }}"
                           [class.disabled] = "isUpdating"
                           title="{{ 'Delete last Layer' | translate }}"
                           (click)="deleteLatestTab({
                                                                url: 'self-report',
                                                                action: 'delete',
                                                                id: params['id'],
                                                                activated: params['activated'],
                                                                title: 'Are you sure you want to delete the last Layer?',
                                                                content: params['content'],
                                                                description: params['description'],
                                                                icon: 'fas fa-ban',
                                                                class: 'modal-confirmation-delete-tab'
                                                            })">

                        </i>
                        <div class="table--grid__header-tab pd-h--sm" *ngFor="let symptomTab of SYMPTOMTABS; let i = index"
                             [class.active]="activeTab === symptomTab['name']"
                             (click)="selectTab(i)">
                            {{ symptomTab['name'] | translate }}
                        </div>
                        <div class="table--grid__header-tab"
                             *ngIf="SYMPTOMTABS.length - 1 < totalSteps && SYMPTOMTABS.length < 8"
                             [class.disabled]="isUpdating"
                             (click)="addOptionTab(true, true)">
                            <i class="fal fa-plus"></i>
                        </div>
                    </div>
                </div>
                <div class="tab-content">
                    <ng-container *ngFor="let symptomTab of SYMPTOMTABS; let tabIndex = index">
                        <div *ngIf="activeTab && activeTab === symptomTab['name']" class="" [class.hidden]="activeTab !== symptomTab['name']">
                            <ng-container *ngIf="tabIndex === 0">
                                <div class="container">
                                    <div class="row mr-t--sm">
                                        <div class="form-group col-xs-4">
                                            <div class="pt-1">
                                                <mat-slide-toggle formControlName="show_circumstances">
                                                    <span class="toggle-text">
                                                        {{ 'Life circumstances' | translate }}
                                                    </span>
                                                </mat-slide-toggle>
                                                <small class="form-text text-danger" [hidden]="!circumstanceRequired">
                                                    {{ 'Life circumstance is required.' | translate }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mr-t--sm" *ngIf="form.controls['show_circumstances'].value">
                                        <div class="col-xs-12 grid-circumstance">
                                            <ng-container *ngFor="let circumstance of circumstances">
                                                <div>
                                                    <input type="checkbox" [id]="'circumstance-' + circumstance.id" (change)="updateCircumstance($event.target.checked, circumstance.id)" [checked]="form.controls['circumstance_ids'].value.indexOf(circumstance.id) >= 0"/>
                                                    <label class="h-100" [for]="'circumstance-' + circumstance.id"> {{ circumstance['name_' + itemLanguage] }}</label>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </ng-container>
                            <div *ngFor="let group of getGroups.controls; let i = index">

                                <div class="container">
                                    <div class="row mr-t--md">
                                        <div *ngIf="step && parentGroups.length" #parent class="form-group col-xs-3">
                                            <mat-form-field class="">
                                                <mat-select #matParent
                                                            [placeholder]="'Parent' | translate"
                                                            class="matSelect-domains"
                                                            [formControl]="group.controls['parent_id']"
                                                >
                                                    <mat-option [value]="0">
                                                        {{ 'None parent' | translate }}
                                                    </mat-option>
                                                    <ng-container *ngFor="let parentItem of parentGroups">
                                                        <mat-option
                                                                [class.hidden]="parentItem['hidden']"
                                                                #matOption
                                                                [value]="parentItem['id']">
                                                            {{ parentItem['id'] }} - {{ parentItem['name']}}
                                                        </mat-option>
                                                    </ng-container>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>

                                        <div #nameFG class="form-group col-xs-5">
                                            <mat-form-field class="ps-content">
                                                <input type="text" matInput [placeholder]="('Group name' | translate)"
                                                       [formControl]="group.controls['name']"/>
                                                <small class="form-text text-danger" [hidden]="(group.controls['name'].valid
                                                                            || group.controls['name'].pristine
                                                                            && !formSubmitted)">
                                                    {{ 'Require at least 3 characters.' | translate }}
                                                </small>
                                            </mat-form-field>
                                        </div>

                                        <div #triggerNo class="form-group col-xs-3">
                                            <mat-form-field class="ps-content">
                                                <input type="text" matInput
                                                       min="1"
                                                       max="99"
                                                       [placeholder]="('Trigger' | translate) + ' ( >= 1)'"
                                                       [formControl]="group.controls['trigger_no']"/>
                                                <small class="form-text text-danger" [hidden]="(group.controls['trigger_no'].valid
                                                                            || group.controls['trigger_no'].pristine
                                                                            && !formSubmitted)">
                                                    {{ 'Require a number and always greater than 1.' | translate }}
                                                </small>
                                            </mat-form-field>
                                        </div>

                                    </div>
                                </div>

                                <div class="container mr-b--md">
                                    <div class="mt-2 row">
                                        <div #feelingName class="form-group col-xs-4">
                                            <mat-form-field class="">
                                                <mat-select #matFeeling required
                                                            [placeholder]="'Feelings' | translate"
                                                            class="matSelect-domains"
                                                            [(ngModel)]="feelingsIdSelectedByGroup[i]"
                                                            [ngModelOptions]="{standalone: true}"
                                                            (openedChange)="toggleMatSelect($event)"
                                                            multiple>
                                                    <input formControlName="searchTxt"
                                                           class="matSelect-domains--filter"
                                                           type="text"
                                                           matInput
                                                           [placeholder]="('Search' | translate)">
                                                    <ng-container *ngFor="let feeling of filteredFeelings | searchArray : form.controls['searchTxt'].value : 'name_' + itemLanguage ">
                                                        <mat-option
                                                                [class.hidden]="feeling['hidden']"
                                                                (click)="toggleFeeling(feeling, i)"
                                                                #matOption
                                                                [value]="feeling['id']">
                                                            {{ feeling['id'] }} - {{ feeling['name_' + itemLanguage] | translate }}
                                                        </mat-option>
                                                    </ng-container>
                                                </mat-select>
                                                <small class="form-text text-danger" [hidden]="(feelingsIdSelectedByGroup[i]?.length > 0 || !formSubmitted)">
                                                    {{ 'Require at least 1 feeling.' | translate }}
                                                </small>
                                            </mat-form-field>
                                        </div>

                                        <div *ngIf="activeTab === this.SYMPTOMTABS[0].name" #age class="form-group offset-xs-2 col-xs-4">
                                            <mat-form-field class="col-xs-6">
                                                <input type="text" matInput [placeholder]="('Min Age' | translate)" class="" [formControl]="group.controls['min_age']" />
                                            </mat-form-field>
                                            <mat-form-field class="col-xs-6">
                                                <input type="text" matInput class="" [placeholder]="('Max Age' | translate)" [formControl]="group.controls['max_age']" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <label class="col-xs-12 lbl-card">
                                            {{ 'Selected feelings' | translate}}
                                        </label>
                                        <div class="col-xs-8 selected-domains">
                                            <ng-container *ngFor="let feeling of feelingsSelectedByGroup[i]">
                                                <div class="row selected-domains--item">
                                                    <div class="col-xs-8">
                                                        <input (click)="toggleSelectedFeeling(feeling, i, $event)"
                                                               [(ngModel)]="feeling['isChecked']"
                                                               [ngModelOptions]="{standalone: true}"
                                                               type="checkbox"
                                                               [id]="'feeling-' + i + '-' + feeling['id']" />
                                                        <label [for]="'feeling-' + i + '-' + feeling['id']" class="mb-0 col-xs-12 ellipsis">
                                                            {{ feeling['id'] }} | {{feeling['name_' + itemLanguage]}} <br/>
                                                        </label>
                                                    </div>
                                                    <ng-templage  *ngIf="(feeling && (feeling['is_acute'] === 0 || feeling['acuteable'] === 0)); else isAcute">
                                                        <div class="col-xs-1 offset-xs-2 feeling-anan">
                                                            <a *ngIf="params['action'] !== 'read'" class="btn btn-link table--grid__action-btn" (click)="switchState(feeling, index)">
                                                                <i class="fal fa-history table--grid__actions__links__icon"></i>
                                                            </a>
                                                        </div>
                                                    </ng-templage>

                                                    <ng-template #isAcute>
                                                        <div class="col-xs-2">
                                                            <a *ngIf="params['action'] !== 'read'" class="btn btn-link table--grid__action-btn">
                                                                <span class="table--grid__actions__links__point">
                                                                    {{ feeling['trigger_point'] }} / 5
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="col-xs-1 feeling-isAcute">
                                                            <a *ngIf="params['action'] !== 'read'" class="btn btn-link table--grid__action-btn" (click)="switchState(feeling)">
                                                                <i class="fas fa-clock table--grid__actions__links__icon"></i>
                                                            </a>
                                                        </div>
                                                    </ng-template>
                                                    <div class="col-xs-1">
                                                        <a *ngIf="params['action'] !== 'read'" class="btn btn-link table--grid__action-btn" (click)="removeFeeling(feeling, i)">
                                                            <i class="far fa-trash-alt table--grid__actions__links__icon"
                                                               attr.name="{{ 'Delete' | translate }}"
                                                               title="{{ 'Delete' | translate }}"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <div class="col-xs-2">
                                            <button [disabled]="checkedFeelings[i]?.length < 1" *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary mb-3" (click)="openMultipleModal(checkedFeelings[i], i)">
                                                {{ 'Update' | translate }}
                                            </button>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-xs-6 offset-xs-3 mt-2 align-content-center">
                                            <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary" (click)="addNewGroupData()">
                                                {{ 'Add group' | translate }}
                                            </button>
                                            <button *ngIf="i > 0" type="button" class="btn btn-secondary" (click)="deleteNewGroupData(i)">
                                                {{ 'Delete' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <hr />
                            </div>
                        </div>
                    </ng-container>


                </div>



                <div class="row">
                    <div class="col-xs-12 text-xs-right">
                        <button type="button" class="btn btn-secondary" (click)="hide()">
                            {{ 'Cancel' | translate }}
                        </button>
                        <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary" (click)="submitData()">
                            {{ 'Submit' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </ng-template>
    </div>
</div>

<!-- Modal -->
<div *ngIf="checkedFeelings.length" bsModal #multipleSymptomsModal="bs-modal" class="modal modal--custom fade" [ngClass]="params['action'] === 'activate' || params['action'] === 'delete' ? 'modal-confirmation': ''" tabindex="-1" role="dialog" aria-hidden="true">

    <div class="modal-dialog">
        <div class="modal-content" *ngIf="params['component'] === 'SrConfiguration'">
            <div class="modal-header">
                <h4 class="modal-title help-btn">
                    {{ 'Update feelings' | translate }}
                </h4>
            </div>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="row">
                    <div class="col-xs-6" *ngIf="acuteableFeelings && acuteableFeelings.length">
                        <h4>
                            {{ "These feelings can be applied to be Acute" | translate }} :
                        </h4>
                        <div class="col-xs-10" *ngFor='let item of acuteableFeelings'>
                            {{ item['name_' + itemLanguage]}}
                        </div>
                    </div>

                    <div class="col-xs-6" *ngIf="ananableFeelings && ananableFeelings.length">
                        <h4>
                            {{ "These feelings can be applied to be Anamnestic" | translate }} :
                        </h4>
                        <div class="col-xs-10" *ngFor='let item of ananableFeelings'>
                            {{ item['name_' + itemLanguage]}}
                        </div>
                    </div>

                    <div class="col-xs-8 mt-2">
                        <input type="radio" id="cb-acute" name="cb-acute-anam" (change)="isAnanmestic = false" />
                        <label for="cb-acute">
                            {{ "Acute Question: I'm no longer interested in my daily activities" | translate }}
                        </label>
                        <div class="row">
                            <div class="col-xs-8">
                                <mat-slider [min]="1" [max]="5" [step]="1" (change)="onStepChange($event)"></mat-slider>
                            </div>
                            <div class="col-xs-8">
                                <div class="slider">
                                    <ng-container *ngFor="let step of points">
                                        <span *ngIf="step > 0" [class]="'slider--value__' + step">{{step}}</span>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-xs-8">
                        <input type="radio" id="cb-anam" name="cb-acute-anam" (change)="isAnanmestic = true"/>
                        <label for="cb-anam">
                            {{ "Anamnestic Question: Have you lost interest in things or activities which you used to enjoy" | translate }}
                        </label>
                    </div>
                </div>
                <div class="row">
                        <div class="col-xs-12 text-xs-right">
                            <button type="button" class="btn btn-secondary" (click)="hideMultipleModal()">
                                {{ 'Cancel' | translate }}
                            </button>
                            <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary" (click)="updateFeelingsData()">
                                {{ 'OK' | translate }}
                            </button>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>
<!--close <div bsModal ...-->

<dialog-component #dialog></dialog-component>